export const SIGNUP_COUPON_STORAGE_KEY = 'signup_coupon_code';

const normalizeCouponCode = (value: string | null): string | null => {
  const code = value?.trim();

  return code || null;
};

export const captureSignupCoupon = (search: string): string | null => {
  const code = normalizeCouponCode(new URLSearchParams(search).get('coupon'));

  if (code) localStorage.setItem(SIGNUP_COUPON_STORAGE_KEY, code);

  return code;
};

export const syncSignupCouponFromLocation = (pathname: string, search: string): string | null => {
  if (pathname !== '/signup') {
    const isCompletingAuth = pathname.startsWith('/auth/callback/')
      || pathname === '/auth/verify-email';

    if (!isCompletingAuth) clearSignupCouponCode();

    return null;
  }

  const code = captureSignupCoupon(search);

  if (!code) clearSignupCouponCode();

  return code;
};

export const getSignupCouponCode = (): string | null => (
  normalizeCouponCode(localStorage.getItem(SIGNUP_COUPON_STORAGE_KEY))
);

export const clearSignupCouponCode = (): void => {
  localStorage.removeItem(SIGNUP_COUPON_STORAGE_KEY);
};
